const headRowsService = {
  item: 'Elemento',
  name: 'Equipo',
  business: 'Tipo de Servicio',
  site: 'Periodicidad'
};

export default headRowsService;
